import Vue from 'vue'
import ApiService from '@/common/api.service'

/**
 * The module's state (VueX store object)
 */
export const state = {
  settings: {}
}

export const getters = {
  /**
   * Returns all the settings
   *
   * @return Object
   */
  get (state) {
    return state.settings
  }
}

export const actions = {
  /**
   * Fetches the currently logged in user's settings from the API.
   *
   * @param context Object
   *
   * @return Promise
   */
  fetch (context) {
    return ApiService
      .get(`users/settings`)
      .then((response) => {
        context.commit('setAll', response.data.data['settings'])
        return response
      })
  },

  /**
   * PUT (update) existing user settings through the API and
   * upon success, updates the local store with all the users
   * settings.
   *
   * @param context Object
   *
   * @return Promise
   */
  put (context) {
    context.commit('set', { name: 'default', value: false })
    return ApiService
      .put(`users/settings`, { settings: context.getters['get'] })
      .then((response) => {
        return response
      })
  }
}

export const mutations = {
  /**
   * Set a single user setting.
   *
   * @param state Object
   * @param properties Object
   */
  setAll (state, properties) {
    if (properties instanceof Array) {
      // This is to circumvent a (now-fixed) bug in the back-end that
      // would return an ampty array instead of an object if there
      // is no settings saved.
      state.settings = {}
    } else {
      Vue.set(state, 'settings', properties)
    }
  },

  /**
   * Set a single user setting.
   *
   * @param state Object
   * @param name  String
   * @param value mixed
   */
  set (state, { name, value }) {
    if (state.settings instanceof Array) {
      // This is to circumvent a (now-fixed) bug in the back-end that
      // would return an empty array instead of an object if there
      // is no settings saved.
      state.settings = {}
    }
    Vue.set(state.settings, name, value)
  },

  reset (state) {
    state.settings = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/accounts/usersSettingsModule.js